var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWarningSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "15px",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "85915582-E97F-4EE2-8181-84BF6B7AB60D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-designs-current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TP-Comp-PBA-Rerun-Modal-2-Alert-1",
    transform: "translate(-1320.000000, -247.000000)",
    fill: "#B00020",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Warning-small",
    transform: "translate(1320.000000, 247.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,15 L9,0 L18,15 L0,15 Z M2.646,13.5 L15.354,13.5 L9,2.917 L2.646,13.5 Z M9,12.5 C9.208,12.5 9.385,12.427 9.531,12.281 C9.677,12.135 9.75,11.958 9.75,11.75 C9.75,11.542 9.677,11.365 9.531,11.219 C9.385,11.073 9.208,11 9,11 C8.792,11 8.615,11.073 8.469,11.219 C8.323,11.365 8.25,11.542 8.25,11.75 C8.25,11.958 8.323,12.135 8.469,12.281 C8.615,12.427 8.792,12.5 9,12.5 Z M8.25,10 L9.75,10 L9.75,6 L8.25,6 L8.25,10 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningSmall);
export default __webpack_public_path__ + "static/media/IconWarningSmall.ad07630e.svg";
export { ForwardRef as ReactComponent };